/**
 * 字典表
 */
 import axios from '../request';
 export default{
    // 查询字典信息
    searchDictionary: params =>{
        return axios({
            url: '/engineering/dict/dictList',
            method: 'post',
            data:params,
            headers: {
              pageNum: params.pageNum,
              pageSize: params.pageSize
            }
        })
    },
    // 添加字典信息
    insertDictionary: params =>
        axios.post('/engineering/dict/dictInsert', params),
    // 修改字典信息
    updateDictionary: params =>
        axios.post('/engineering/dict/dictUpdate', params),
    // 字典信息详情
    detailsDictionary: params =>
        axios.get('/engineering/dict/dictInfo', {params}),
    // 删除字典信息
    deleteDictionary: params =>
        axios.get('/engineering/dict/dictDel', {params}),
    //类别下拉框
    getAllTypeLists: params =>
        axios.get('/engineering/dict/dictTypePull', {params}),
 }